import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClockLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12ZM11 10.7637V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V10.7637L13.0098 10.9023C13.0289 11.0393 13.0762 11.1716 13.1494 11.29C13.247 11.4478 13.3868 11.5752 13.5527 11.6582L16.4473 13.1055C16.9412 13.3525 17.1415 13.9533 16.8945 14.4473C16.6475 14.9412 16.0467 15.1415 15.5527 14.8945L12.6592 13.4473C12.1608 13.1982 11.7413 12.8157 11.4482 12.3418C11.1552 11.8678 11 11.3209 11 10.7637ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		fill: "currentColor"
	})
});
export default SvgClockLine;
